module.exports = __webpack_public_path__ + "img/footerb_3008.9ed93395.jpg";